/**
 * Per-targeted-component fallback (handover §9) — what a component does with a recipient
 * who has NO data on a rule's dimension. Only relaxes genre_history / show_type_history /
 * movie_label / gender / product_tag; every other dimension hard-matches.
 */
export enum CrmComponentFallback {
  Show = 0,
  Skip = 1,
}
